import React from 'react';
import styled from 'styled-components';

import { Hint, Link as LinkStyle } from 'venn-ui-kit';

const LearnMoreAction = ({ href }: { href: string }) => (
  <Hint>
    Or{' '}
    <LinkStyle>
      <HelpCenterLink target="_blank" rel="noopener noreferrer" href={href} className="qa-home-visit-help-center">
        visit the help center
      </HelpCenterLink>
    </LinkStyle>{' '}
    to learn more.
  </Hint>
);

const HelpCenterLink = styled.a`
  font-weight: bold;
`;

export default LearnMoreAction;
